import React, { useState, useEffect, useMemo } from 'react';
import { Row } from 'react-bootstrap';
import { formatMoney } from 'helpers/Currency';
import DashboardRequestService from 'services/dashboard-request';
import "./style.scss";
import CardValue from 'components/CardValue';

export default function CardFundScancashMinimalist({ fiscalYear, companyId }){
  const [ funds, setFunds ] = useState({ 
    rebate_paid: 0, 
    rebate_running: 0, 
    scancash_running: 0, 
    scancash_paid: 0,
    transferred_innovation: 0,
    scancash_balance: 0,
    scancash_value: 0,
    scancash_total: 0,
  });

  const [ load, setLoad ] = useState(true)
  const filter = useMemo(()=>{
    let filter = {
      __fund_type_id: 3,
      __fiscal_year_id: fiscalYear,
    }
    if(!!companyId){
      filter.__company_id = companyId
    }

    return filter;
  },[fiscalYear, companyId])

  useEffect(()=>{
    setLoad(true)
    DashboardRequestService.getFundValues({
      params: filter
    }).then(({data})=>{
      setFunds({
        scancash_value: data.valor_liberado,
        scancash_running: data.valor_pendente,
        scancash_paid: data.valor_resgatado,
        scancash_new: data.valor_pedido
      });
      setLoad(false)
    })
  },[filter]);

  return (
    <Row>
      <CardValue
        md="4"
        title="Saldo Disponível" 
        value={formatMoney(funds.scancash_value)} 
        load={load}
      />
      <CardValue 
        md="4"
        title="Valor aguardando liberação" 
        value={formatMoney(funds.scancash_running?funds.scancash_running:0)} 
        load={load}
      />
      <CardValue 
        md="4"
        title="Valor resgatado" 
        value={formatMoney(funds.scancash_paid?funds.scancash_paid:0)} 
        load={load}
      />
    </Row>
  );
}